import { Fragment } from 'react';
import List from '@mui/material/List';
import { Link } from 'react-router-dom';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
// import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ListItemButton from '@mui/material/ListItemButton';
import { Box, Button, Divider } from '@mui/material';
import { useTranslation } from '../hook/Translation';
import CloseIcon from '@mui/icons-material/Close';
export default function RecursiveMenu({ items, openCollapses, handleToggleCollapse, handleDrawerToggle, level = 0 }) {
    const { t } = useTranslation();
    return (
        <List component="div" disablePadding>
            {
                level === 0 &&
                <Box sx={{ mx: 'auto', width: '90%' }}>
                    <Box sx={{ width: 'max-content', ml: 'auto', mt: '20px' }}>
                        <CloseIcon sx={{ color: 'text.secondary' }} onClick={() => handleDrawerToggle()} />
                    </Box>
                    <Divider sx={{ mt: '15px' }} />
                </Box>
            }
            {items.map((item, index) => {
                const hasChildren = item.submenu;
                return (
                    <Fragment key={`${item.name}-${index}`}>
                        <ListItem disablePadding>
                            {
                                item?.name &&
                                <ListItemButton
                                sx={{ pl: 2 + level * 0 }} // indentation for nested levels
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (hasChildren) handleToggleCollapse(item.name);
                                    else handleDrawerToggle();
                                }}
                                component={item.link ? Link : 'div'} to={item.link || undefined}
                            >
                                {
                                    item?.name &&
                                    <ListItemText
                                    primary={item?.name}
                                    sx={{
                                        color: 'text.secondary',
                                        '.MuiTypography-root': {
                                            fontWeight: [
                                                 level === 0
                                                    ? '800'
                                                    : level === 1
                                                        ? '800'
                                                        : '500'
                                            ],
                                            fontSize:
                                                level === 0
                                                    ? '1.125rem'
                                                    : level === 1
                                                        ? '1rem'
                                                        : '0.9rem'
                                        }
                                    }}
                                />
                                }
                                

                                {item.collapsible ? openCollapses[item.name] ? <ExpandLess htmlColor='#000' /> : <ExpandMore htmlColor='#000' /> : null}
                            </ListItemButton>
                            }
                            
                        </ListItem>
                        {
                            item.name &&
                            <Divider />
                        }
                        
                        {item.submenu && (
                            <Collapse in={openCollapses[item.name]} timeout="auto" unmountOnExit>
                                <RecursiveMenu
                                    items={item.submenu}
                                    openCollapses={openCollapses}
                                    handleToggleCollapse={handleToggleCollapse}
                                    handleDrawerToggle={handleDrawerToggle}
                                    level={level + 1}
                                />
                            </Collapse>
                        )}

                        {item.menu && (
                            <RecursiveMenu
                                items={item.menu}
                                openCollapses={openCollapses}
                                handleToggleCollapse={handleToggleCollapse}
                                handleDrawerToggle={handleDrawerToggle}
                                level={level + 1}
                            />
                        )}
                    </Fragment>
                );
            })}
            {/* <Divider sx={{ mt: '15px' }} /> */}
            {
                level === 0 &&
                <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} marginX={'auto'} gap={2} mt={'20px'}>
                    <Button variant='outlined' LinkComponent={Link} to="/login" sx={{ background: 'transparent', borderColor: '#1E353D', color: '#1E353D', borderRadius: 0, borderWidth: '2px', fontSize: '1.125rem', width: '90%', textTransform: 'none', fontWeight: 'bold' }}>
                        Rinu+
                    </Button>
                    <Button variant='contained' LinkComponent={Link} to="/booknow" sx={{ background: '#1E353D', borderRadius: 0, borderWidth: '2px', color: '#FFF', fontSize: '1.125rem', width: '90%', textTransform: 'none', boxShadow: 'none' }}>
                        {t('book_now')}
                    </Button>
                </Box>
            }

        </List>
    );
}
